import ProtectedRoute from '../protectedRoute/ProtectedRoute';

/**
 * AdminRoute component that checks if user is authenticated and is an admin
 * Redirects to login if not authenticated, or home if not admin
 */
const AdminRoute = ({ children }) => {
  return <ProtectedRoute requireRole="ADMIN">{children}</ProtectedRoute>;
};

export default AdminRoute;

